function getVariantFromUrl() {
  const params = new URLSearchParams(window.location.search);
  return params.get('variant');
}

function fetchInventory(el, variantId, proxyUrl) {
  if (!variantId) return;

  el.innerHTML = '<span>Checking stock…</span>';

  fetch(proxyUrl + '?variant_id=' + variantId)
    .then(function(res) {
      if (!res.ok) throw new Error('HTTP ' + res.status);
      return res.json();
    })
    .then(function(data) {
      renderInventory(el, data);
    })
    .catch(function(err) {
      console.error('[Inventory] Fetch failed:', err);
      el.innerHTML = '<span style="color:red;font-size:13px;">Could not load stock info.</span>';
    });
}

function renderInventory(el, data) {
  var locations = data.locations || [];
  var usa    = null;
  var canada = null;

  for (var i = 0; i < locations.length; i++) {
    if (locations[i].location === 'Gray Tools USA Warehouse')    usa    = locations[i];
    if (locations[i].location === 'Gray Tools Canada Warehouse') canada = locations[i];
  }

  var message, color;

  if (usa && usa.available > 0) {
    message = 'Ships in 1 Business Day';
    color   = 'green';
  } else if (canada && canada.available > 0) {
    message = 'Ships within 10 Business Days';
    color   = 'orange';
  } else {
    message = 'Out of stock';
    color   = 'red';
  }

  el.innerHTML = '<span>' + message + '</span>';
}

function initInventoryWidget() {
  var el = document.getElementById('inventory-by-location');
  if (!el) {
    console.warn('[Inventory] Element not found');
    return;
  }

  var proxyUrl      = el.dataset.proxyUrl;
  var lastVariantId = el.dataset.variantId;

  // Initial load
  fetchInventory(el, lastVariantId, proxyUrl);

  // Watch URL for variant param changes
  var interval = setInterval(function() {
    var currentVariantId = getVariantFromUrl() || el.dataset.variantId;
    if (currentVariantId && currentVariantId !== lastVariantId) {
      lastVariantId = currentVariantId;
      fetchInventory(el, currentVariantId, proxyUrl);
    }
  }, 300);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initInventoryWidget);
} else {
  initInventoryWidget();
}